function bindAddToCartButtons(){let e=document.querySelector(".cart-notification");document.querySelectorAll(".addtocart").forEach(t=>{t.addEventListener("click",function(){setTimeout(()=>{let e=document.querySelector(".header__icon--cart");if(e&&!e.querySelector(".cart-count-bubble")){let t=document.createElement("div");t.className="cart-count-bubble",e.appendChild(t)}},2e3);let t=this.getAttribute("data-variant-id");if(!t)return;let r=this.closest(".card--card"),o=r?.querySelector("img"),c=r?.querySelector(".turncatecls")?.innerHTML||"",n=e.querySelector(".collection_product_popup"),i=e.querySelector(".title_product_popup");n&&o&&n.setAttribute("src",o.getAttribute("src")||o.getAttribute("srcset")),i&&(i.innerHTML=c),fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:t,quantity:1})}).then(e=>e.json()).then(()=>{e.classList.add("active"),e.querySelector(".container_img_heading")?.classList.add("active"),setTimeout(()=>{e.classList.remove("active"),e.querySelector(".container_img_heading")?.classList.remove("active")},4e3),updateCartCount()}).catch(e=>{console.error("Error adding to cart:",e)})})}),document.querySelector(".cart-notification .close-button")?.addEventListener("click",()=>{e.classList.remove("active")})}function updateCartCount(){fetch("/cart.js").then(e=>e.json()).then(e=>{let t=e.item_count;console.log(t);let r=setInterval(()=>{let e=document.querySelector(".cart-count-bubble");e&&(e.textContent=t,t>0?(e.style.display="block",e.classList.remove("hidden","opacity-0")):e.style.display="none",clearInterval(r))},100);setTimeout(()=>clearInterval(r),1e3)})}document.addEventListener("DOMContentLoaded",function(){if(window.location.href.includes("collections")&&window.innerWidth>768){let e=document.querySelector(".facets-container");e&&window.addEventListener("scroll",function(){let t=window.scrollY||document.documentElement.scrollTop,r=document.documentElement.scrollHeight,o=window.innerHeight;t>580?e.classList.add("sticky"):e.classList.remove("sticky"),r-(t+o)<.3*window.innerHeight?e.style.display="none":e.style.display="block"})}}),window.addEventListener("scroll",function(){let e=document.querySelector("main.collection .facets-vertical .facets-wrapper");e&&(window.scrollY>340?e.classList.add("is-sticky"):e.classList.remove("is-sticky"))}),document.addEventListener("DOMContentLoaded",bindAddToCartButtons),document.querySelectorAll(".benefit-item").forEach(e=>{let t=e.parentElement,r=t.querySelectorAll(".benefit-item");2===r.length?(t.classList.add("product_benfits_two"),t.classList.remove("product_benfits_one")):1===r.length?(t.classList.add("product_benfits_one"),t.classList.remove("product_benfits_two")):(t.classList.remove("product_benfits_one"),t.classList.remove("product_benfits_one"))}),document.addEventListener("DOMContentLoaded",()=>{window.location.href.includes("/products/")&&window.location.href.includes("mirror")&&(document.querySelector(".product__info-wrapper").classList.add("product_info_cstm"),setTimeout(()=>{let e=document.querySelector(".appattic_price_app_div");e&&e.classList.add("cstm_hide")},3e3))}),document.addEventListener("DOMContentLoaded",()=>{let e=document.querySelector(".lern_more_txt"),t=document.querySelector(".volume-quote-wrapper"),r=document.querySelector(".close_popup"),o=document.body;e&&t&&r&&(e.addEventListener("click",()=>{t.classList.toggle("volume-quote-block"),t.classList.contains("volume-quote-block")?o.style.overflow="hidden":o.style.overflow=""}),r.addEventListener("click",()=>{t.classList.remove("volume-quote-block"),o.style.overflow=""}))}),document.addEventListener("DOMContentLoaded",function(){let e=document.getElementById("richTextWrapper");if(!e)return;let t=Array.from(e.querySelectorAll("p")),r=[];for(let o=0;o<t.length;o+=2){let c=document.createElement("div");c.classList.add("wrapper_content_meta"),t[o]&&c.appendChild(t[o]),t[o+1]&&c.appendChild(t[o+1]),r.push(c)}e.innerHTML="",r.forEach(t=>e.appendChild(t))}),document.addEventListener("DOMContentLoaded",function(){window.location.href.includes("mirror")&&document.querySelectorAll(".wattage_card_desktop").forEach(e=>{e.classList.add("mirror_wattage")})});



// Variant change price update
document.querySelectorAll('.addon-variant-select').forEach(select => {
  select.addEventListener('change', function () {
    const selectedOption = this.options[this.selectedIndex];
    const price = selectedOption.getAttribute('data-price');

    const priceDisplay = this.closest('.addon-item').querySelector('.addon-variant-price');
    if (priceDisplay) {
      priceDisplay.textContent = price;
    }
  });
});


// Open popup when clicking image or title
document.querySelectorAll('.addon-item').forEach((addonItem, index) => {
  const clickableElements = addonItem.querySelectorAll('.product_popup_title_add_ons, .product_popup_image');

  clickableElements.forEach(element => {
    element.addEventListener('click', () => {
      const popups = document.querySelectorAll('.popup_addons_item_container');

      popups.forEach((popup, popupIndex) => {
        popup.style.display = (popupIndex === index) ? 'block' : 'none';
      });

      // Force slick slider to recalculate layout
      setTimeout(() => {
        $('.image_container_addons_product').slick('setPosition');
      }, 100);
    });
  });
});


// Close popup add-ons button
document.querySelectorAll('.close-button_product-add-ons').forEach((btn) => {
  btn.addEventListener("click", () => {
    document.querySelectorAll('.popup_addons_item_container').forEach((popup) => {
      popup.style.display = "none";
    });
  });
});


// Quantity plus/minus buttons
document.querySelectorAll('.addon-quantity-wrapper').forEach(wrapper => {
  const input = wrapper.querySelector('.addon-quantity');
  const plus = wrapper.querySelector('.plus');
  const minus = wrapper.querySelector('.minus');

  plus.addEventListener('click', () => {
    input.value = parseInt(input.value || 1) + 1;
  });

  minus.addEventListener('click', () => {
    input.value = Math.max(1, parseInt(input.value || 1) - 1);
  });
});


// Show quantity input only when checkbox is checked
document.querySelectorAll('.addon-checkbox').forEach(checkbox => {
  checkbox.addEventListener('change', function () {
    const wrapper = this.closest('.addon-item');
    const quantityWrapper = wrapper.querySelector('.addon-quantity-wrapper');
    
    if (this.checked) {
      quantityWrapper.style.display = 'inline-flex';
    } else {
      quantityWrapper.style.display = 'none';
    }
  });
});


if (
  window.location.href.includes("ufo-high-bay") ||
   window.location.href.includes("led-vapor-tight-fixture")

) {
  document.body.classList.add("cstm-ceiling");
}

// document.addEventListener("DOMContentLoaded", function () {

//   const keywords = [
//     "led-ceiling-panel",
//     "led-frame-light",
//     "led-t-bar-light-",
//     "led-troffer-retrofit-",
//     "led-troffer-light-"
//   ];

//   const urlMatch = keywords.some(keyword => window.location.href.includes(keyword));

//   {% if product.tags contains "LED Ceiling Troffer Light" %}
//     const tagMatch = true;
//   {% else %}
//     const tagMatch = false;
//   {% endif %}

//   if (urlMatch || tagMatch) {
//     document.body.classList.add("cstm-ceiling");
//   }

// });

